module.exports = __webpack_public_path__ + "media/images/rocket-22f00f106068950419b696a979c7eb4b.svg";